export default {
  "root": "_root_1sgsi_1",
  "--border-neutral": "_--border-neutral_1sgsi_1",
  "--border-neutral-faded": "_--border-neutral-faded_1sgsi_1",
  "--border-positive": "_--border-positive_1sgsi_1",
  "--border-positive-faded": "_--border-positive-faded_1sgsi_1",
  "--border-warning": "_--border-warning_1sgsi_1",
  "--border-warning-faded": "_--border-warning-faded_1sgsi_1",
  "--border-critical": "_--border-critical_1sgsi_1",
  "--border-critical-faded": "_--border-critical-faded_1sgsi_1",
  "--border-primary": "_--border-primary_1sgsi_1",
  "--border-primary-faded": "_--border-primary-faded_1sgsi_1",
  "--border-disabled": "_--border-disabled_1sgsi_1",
  "--border-brand": "_--border-brand_1sgsi_1",
  "--border-transparent": "_--border-transparent_1sgsi_1",
  "--border-neutral--m": "_--border-neutral--m_1sgsi_1",
  "--border-neutral-faded--m": "_--border-neutral-faded--m_1sgsi_1",
  "--border-positive--m": "_--border-positive--m_1sgsi_1",
  "--border-positive-faded--m": "_--border-positive-faded--m_1sgsi_1",
  "--border-warning--m": "_--border-warning--m_1sgsi_1",
  "--border-warning-faded--m": "_--border-warning-faded--m_1sgsi_1",
  "--border-critical--m": "_--border-critical--m_1sgsi_1",
  "--border-critical-faded--m": "_--border-critical-faded--m_1sgsi_1",
  "--border-primary--m": "_--border-primary--m_1sgsi_1",
  "--border-primary-faded--m": "_--border-primary-faded--m_1sgsi_1",
  "--border-disabled--m": "_--border-disabled--m_1sgsi_1",
  "--border-brand--m": "_--border-brand--m_1sgsi_1",
  "--border-transparent--m": "_--border-transparent--m_1sgsi_1",
  "--border-neutral--l": "_--border-neutral--l_1sgsi_1",
  "--border-neutral-faded--l": "_--border-neutral-faded--l_1sgsi_1",
  "--border-positive--l": "_--border-positive--l_1sgsi_1",
  "--border-positive-faded--l": "_--border-positive-faded--l_1sgsi_1",
  "--border-warning--l": "_--border-warning--l_1sgsi_1",
  "--border-warning-faded--l": "_--border-warning-faded--l_1sgsi_1",
  "--border-critical--l": "_--border-critical--l_1sgsi_1",
  "--border-critical-faded--l": "_--border-critical-faded--l_1sgsi_1",
  "--border-primary--l": "_--border-primary--l_1sgsi_1",
  "--border-primary-faded--l": "_--border-primary-faded--l_1sgsi_1",
  "--border-disabled--l": "_--border-disabled--l_1sgsi_1",
  "--border-brand--l": "_--border-brand--l_1sgsi_1",
  "--border-transparent--l": "_--border-transparent--l_1sgsi_1",
  "--border-neutral--xl": "_--border-neutral--xl_1sgsi_1",
  "--border-neutral-faded--xl": "_--border-neutral-faded--xl_1sgsi_1",
  "--border-positive--xl": "_--border-positive--xl_1sgsi_1",
  "--border-positive-faded--xl": "_--border-positive-faded--xl_1sgsi_1",
  "--border-warning--xl": "_--border-warning--xl_1sgsi_1",
  "--border-warning-faded--xl": "_--border-warning-faded--xl_1sgsi_1",
  "--border-critical--xl": "_--border-critical--xl_1sgsi_1",
  "--border-critical-faded--xl": "_--border-critical-faded--xl_1sgsi_1",
  "--border-primary--xl": "_--border-primary--xl_1sgsi_1",
  "--border-primary-faded--xl": "_--border-primary-faded--xl_1sgsi_1",
  "--border-disabled--xl": "_--border-disabled--xl_1sgsi_1",
  "--border-brand--xl": "_--border-brand--xl_1sgsi_1",
  "--border-transparent--xl": "_--border-transparent--xl_1sgsi_1"
};import "ni:sha-256;R8u7qvAkXRWb0XN5uI3ntIOW8bcOeRp6eQCfuC2rc78";